module.exports = __webpack_public_path__ + "img/icone-pessoa-fisica.382541cb.png";